import { render } from "./LeadgenFormBlock.vue?vue&type=template&id=c48c2234"
import script from "./LeadgenFormBlock.vue?vue&type=script&lang=js"
export * from "./LeadgenFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/LeadgenFormBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c48c2234"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c48c2234', __exports__)) {
    api.reload('c48c2234', __exports__)
  }
  
  module.hot.accept("./LeadgenFormBlock.vue?vue&type=template&id=c48c2234", () => {
    api.rerender('c48c2234', render)
  })

}


export default __exports__